module.exports = __webpack_public_path__ + "static/media/1027.5bf4164c.pdf";